export const productSolutionMenu = [
    {
        id: 7,
        text: "Sản Phẩm Công Ty",
        slug: "san-pham-cong-ty",
        img: require("../../images/960x0.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---giai-phap-y-te.jpg")
    },
    {
        id: 1,
        text: "Giải Pháp Y Tế",
        slug: "giai-phap-y-te",
        img: require("../../images/product_solution/banner---home-giai-phap-y-te.png"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---giai-phap-y-te.jpg"),

    },
    {
        id: 2,
        text: "Tích hợp hệ thống",
        slug: "tich-hop-he-thong",
        img: require("../../images/product_solution/banner---home-tich-hop-he-thong.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---tich-hop-he-thong.jpg"),
    },
    {
        id: 3,
        text: "Dịch vụ và hạ tầng CNTT",
        slug: "dich-vu-va-ha-tang-cntt",
        img: require("../../images/product_solution/banner---home-ha-tang-cntt.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---dich-vu-va-ha-tang-cntt.jpg"),
    },
    {
        id: 4,
        text: "Giải pháp doanh nghiệp 4.0",
        slug: "giai-phap-doanh-nghiep-40",
        img: require("../../images/product_solution/banner---home-giai-phap-doanh-nghiep-4-0.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---giai-phap-doanh-nghiep-4-0.jpg"),
    },
    {
        id: 5,
        text: "Dịch vụ Cloud",
        slug: "dich-vu-dam-may",
        img: require("../../images/product_solution/banner---home-giai-phap-cloud.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---dich-vu-cloud.jpg"),
    },
    {
        id: 6,
        text: "Giải pháp IOT",
        slug: "giai-phap-iot",
        img: require("../../images/product_solution/banner---home-giai-phap-iot.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---giai-phap-iot.jpg"),
    },
]
